<template>
	<div class="input" :class="className">
		<label v-if="hasLocalizedLabel" :for="resolvedId" class="input__label">
			{{ localizedLabel }}
		</label>
		<div class="input__wrapper">
			<input
			:id="resolvedId"
			type="text"
			class="input__el"
			:placeholder="localizedPlaceholder"
			:value="modelValue || ''"
			:aria-invalid="showError ? 'true' : undefined"
			:aria-errormessage="showError ? errorId : undefined"
			v-bind="$attrs"
			@input="onInput"
			@change="onChange"
		/>
			<div v-if="hasIcon" class="input__icon" aria-hidden="true" v-html="icon"></div>
			<div class="input__error" :aria-hidden="!showError" :id="errorId" role="alert">
				{{ showError ? error : '' }}
			</div>
		</div>
	</div>
</template>

<script setup>
// @ts-nocheck
import { computed } from 'vue';

defineOptions({
	inheritAttrs: false
});

const props = defineProps({
	modelValue: {
		type: String,
		default: ''
	},
	className: {
		type: [String, Array, Object],
		default: ''
	},
	labelUk: {
		type: String,
		default: ''
	},
	labelRu: {
		type: String,
		default: ''
	},
	placeholderUk: {
		type: String,
		default: ''
	},
	placeholderRu: {
		type: String,
		default: ''
	},
	id: {
		type: String,
		default: 'input__label'
	},
	icon: {
		type: String,
		default: ''
	},
	hasError: {
		type: Boolean,
		default: false
	},
	error: {
		type: String,
		default: ''
	}
});

const emit = defineEmits(['update:modelValue', 'change', 'clear-error']);

const locale = computed(() => {
	const shopLocale = window?.['Shopify']?.locale;
	if (shopLocale) {
		return String(shopLocale).toLowerCase();
	}

	const lang = document?.documentElement?.lang;
	return lang ? String(lang).toLowerCase() : 'uk';
});

const isUk = computed(() => locale.value.startsWith('uk'));

const hasLocalizedLabel = computed(() => Boolean(props.labelUk && props.labelRu));

const localizedLabel = computed(() => (isUk.value ? props.labelUk : props.labelRu));

const localizedPlaceholder = computed(() => {
	if (!(props.placeholderUk && props.placeholderRu)) {
		return '';
	}

	return isUk.value ? props.placeholderUk : props.placeholderRu;
});

const resolvedId = computed(() => props.id || 'input__label');

const errorId = computed(() => `${resolvedId.value}-error`);

const hasIcon = computed(() => Boolean(props.icon));

const showError = computed(() => props.hasError && Boolean(props.error));

const onInput = (event) => {
	emit('update:modelValue', event.target.value);
	if (props.hasError) {
		emit('clear-error');
	}
};

const onChange = (event) => {
	emit('change', event.target.value);
	if (props.hasError) {
		emit('clear-error');
	}
};
</script>